import VerticalTrackCardLeftImage from './background/selectTracksPage/verticalTrackCardLeftImage.svg';
import VerticalTrackCardMiddleImage from './background/selectTracksPage/verticalTrackCardMiddleImage.svg';
import VerticalTrackCardRightImage from './background/selectTracksPage/verticalTrackCardRightImage.svg';
import knowledgehutIo from '../assets/icons/logoIcons/knowledgehut.png'

import AlertIconOriginal from './icons/common/alertIconOriginal.svg';
import CollapseIcon from './icons/common/collapseIcon.svg';
import ExpandIcon from './icons/common/expandIcon.svg';
import CollapseCircle from './icons/common/collapseCircle.svg';
import ExpandCircle from './icons/common/expandCircle.svg';


import GreyCircleIcon from './icons/questionStatusIcons/greyCircleIcon.svg';
import FeedbackUnderReviewIcon from './icons/questionStatusIcons/feedbackUnderReview.svg'
import FeedbackReceivedIcon from './icons/questionStatusIcons/feedbackReceived.svg'
import FeedbackUnderReviewIcon_Anim from './icons/questionStatusIcons/feedbackUnderReview_animation.gif'
import FeedbackReceivedIcon_Anim from './icons/questionStatusIcons/feedbackReceived_animation.gif'

import HumanHeadIcon from './icons/selectTracksPage/humanHeadIcon.svg';
import WebDevelopmentIcon from './icons/selectTracksPage/webDevelopmentIcon.svg';
import HumanGroupIcon from './icons/selectTracksPage/humanGroup.svg';
import HumanLaptopDarkIcon from './icons/selectTracksPage/humanLaptopDark.svg';
import HumanLaptopLightIcon from './icons/selectTracksPage/humanLaptopLight.svg';

import GitHubIcon from './icons/socialIcons/githubIcon.svg';
import GoogleIcon from './icons/socialIcons/googleIcon.svg';
import LinkedInIcon from './icons/socialIcons/linkedInIcon.svg';

// from shared assets
import { BASE_ASSETS_URL, DEFAULT_MARKET_NAME } from '../utilities/constants';

const BulbIcon = `${BASE_ASSETS_URL}/${DEFAULT_MARKET_NAME}/icons/bulbIcon.svg`;
const BlueInterviewHelpLogoIcon = `${BASE_ASSETS_URL}/${DEFAULT_MARKET_NAME}/icons/logos/blueInterviewHelpLogoIcon.svg`;
const WhiteInterviewHelpLogoIcon = `${BASE_ASSETS_URL}/${DEFAULT_MARKET_NAME}/icons/logos/whiteInterviewHelpLogoIcon.svg`;
const knowledgehutIcon = knowledgehutIo;

export {
  VerticalTrackCardLeftImage,
  VerticalTrackCardMiddleImage,
  VerticalTrackCardRightImage,
  AlertIconOriginal,
  CollapseIcon,
  ExpandIcon,
  BlueInterviewHelpLogoIcon,
  WhiteInterviewHelpLogoIcon,
  GreyCircleIcon,
  BulbIcon,
  HumanHeadIcon,
  WebDevelopmentIcon,
  HumanGroupIcon,
  HumanLaptopDarkIcon,
  HumanLaptopLightIcon,
  GitHubIcon,
  GoogleIcon,
  LinkedInIcon,
  FeedbackUnderReviewIcon,
  FeedbackReceivedIcon,
  FeedbackUnderReviewIcon_Anim,
  FeedbackReceivedIcon_Anim,
  CollapseCircle,
  ExpandCircle,
  knowledgehutIcon
};
